import { createClient } from '@supabase/supabase-js';

// Support both Vite (VITE_) and CRA (REACT_APP_) prefixes for compatibility
const supabaseUrl = 
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_URL) ||
  process.env.REACT_APP_SUPABASE_URL || 
  'https://lgpvhmifwsjaqaovuogq.supabase.co';

const supabaseAnonKey = 
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_ANON_KEY) ||
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  process.env.REACT_APP_SUPABASE_ANON ||
  '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
